export default class SubscriptionQuery {

    public static CreateSubscription = `mutation CreateSubscriptionQuery($input: CreateSubscriptionInput) {
        createSubscription(input: $input) {
            subscriptionId
        }
    }`;

    public static CancelSubscription = `mutation CancelSubscriptionQuery($input: CancelSubscriptionInput) {
        cancelSubscription(input: $input) {
            confirmationId
        }
    }`;
}